import React from 'react'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import { Box } from 'components/_new/layout'
import { Button } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'
import MobileModal from 'components/_new/modal/MobileModal/MobileModal'

import messages from './messages'


const close = () => actions.models.modals.close(constants.modals.humble.ServerError)

const ServerErrorModal = ({ data: { title, text } }) => (
  <MobileModal title={title || messages.title} onBackdropClick={close}>
    <Text message={text || messages.text} html />
    <Box mt={36}>
      <Button
        title={messages.buttonTitle}
        color="brand"
        size="md"
        weight="normal"
        fullWidth
        onClick={close}
      />
    </Box>
  </MobileModal>
)


export default ServerErrorModal
